import template from './rent-helper.jade';
import { EPreferredCommunicationType } from '../../../../../shared/redux/reducers';

export default () => {
  return {
    template,
    scope: {},
    controller: [
      '$rootScope',
      '$cookies',
      'analyticsService',
      'deviceService',
      'rentHelperService',
      'config',
      'store',
      function ($rootScope, $cookies, analyticsService, deviceService, rentHelperService) {
        this.isInExperiment = false;

        this.isMobile = deviceService.isMobile;
        this.formImageUrl = require('../../../resources/assets/images/rent-helper/own.png');
        this.phoneImageUrl = require('../../../resources/assets/images/rent-helper/specialistHelp.png');
        if (this.isInExperiment) {
          this.formImageUrl = require('../../../resources/assets/images/rent-helper/form.svg');
          this.phoneImageUrl = require('../../../resources/assets/images/rent-helper/phone.svg');
        }

        this.handlerCommunicationFormClickHelper = () => {
          analyticsService.trackCommunicationClick('forms');
          rentHelperService.changeCommunicationTypeToForms(EPreferredCommunicationType.Forms);
          $rootScope.$emit('addForm.updateSegments');
        };

        this.handlerCommunicationPhoneClickHelper = () => {
          analyticsService.trackCommunicationClick('phone');
          rentHelperService.changeCommunicationTypeToForms(EPreferredCommunicationType.Phone);
          $rootScope.$emit('addForm.updateSegments');
        };
      },
    ],
    controllerAs: 'rentHelperCtrl',
    replace: true,
  };
};
